import eventBus from './api/eventBus';

const playerWindowUrl = () => {
  const origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
  return `${origin}/player`;
};

export const PLAY_CHANNEL = 'PLAY_CHANNEL';
export const STOP_CHANNEL = 'STOP_CHANNEL';
export const PLAYER_POPUP_READY = 'PLAYER_POPUP_READY';

export const getPlayerWindow = () => {
  const globalPlayer = window.Site.player;
  if (typeof globalPlayer === 'undefined' || globalPlayer === null || globalPlayer.closed) {
    return null;
  }
  return globalPlayer;
};

export const isClosed = () => {
  const globalPlayer = getPlayerWindow();
  return globalPlayer === null;
};

// Listen to messages send from the player popup window
const onMessageFromPlayer = (evt) => {  
  const { action, value } = evt;
  if (action && action !== PLAYER_POPUP_READY) {
    eventBus.$emit(action, value); // notify local vue apps
  }
};

// Listen for messages from player popup window
export const onMessage = (cb, action) => {
  const receiveMessage = (event) => {
    const { data } = event;
    // ignore messages not originating from the player popup window (webpack hot reloading, ...)
    if (!data.action) { return; }
    if (action && data.action !== action) { return; }
    // if (once === true) {
    //   window.removeEventListener('message', receiveMessage, false);
    // }
    cb(data);
  };

  window.addEventListener('message', receiveMessage, false);
};

export const openPlayerWindow = (channelId) => {
  if (isClosed()) {
    const url = playerWindowUrl() + '/' + channelId;
    const newGlobalPlayer = window.open(url, 'JoePlayer', 'status=1,width=640,height=620');
    window.Site.player = newGlobalPlayer;
    onMessage(onMessageFromPlayer);
    return newGlobalPlayer;
  }
  return getPlayerWindow();
};

// Send messages to player popup window
export const postMessage = (data) => {
  if (isClosed()) { return false; }
  const { action, value } = data;
  const globalPlayer = getPlayerWindow();
  const url = playerWindowUrl();
  // Put messages on the event bus so other vue components can react to the
  // event (ex: change channel ).

  eventBus.$emit(action, value);
  return globalPlayer.postMessage(data, url);
};

// Send messages from player popup window to the main window
export const postMessageToOpener = (data) => {
  if (window.opener) {
    try {
      window.opener.postMessage(data, window.opener.location.href);
    } catch (error) {
      // We don't seem to have access
    }
  }
};

// Send play message to player window
export const play = (data) => {
  if (isClosed()) {
    // wait for player window to complete loading
    const onPlayerPopupReady = () => {
      postMessage(data);
    };
    onMessage(onPlayerPopupReady, PLAYER_POPUP_READY, true);
    // open player window
    openPlayerWindow(data.value.id);
  } else {
    postMessage(data);
  }
};
